// extracted by mini-css-extract-plugin
export default {"container":"mannschaftssportpage_container__VHauD","abteilungen":"mannschaftssportpage_abteilungen__wd9NZ"};